import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { Box } from '../Box/Box';
import { TabsContext } from './Tabs.context';
import { Tab } from './components';
export const Tabs = ({ onChange, value, children, align = 'center' }) => {
    const contentRef = useRef(null);
    const contentId = 'tab-content';
    return (_jsxs(TabsContext.Provider, { value: { contentRef, contentId, value, onChange }, children: [_jsx(Box, { display: 'flex', px: 'sm', justifyContent: align, gap: 'lg', style: { borderBottom: '0.5px solid #CBCDD1' }, children: children }), _jsx("div", { ref: contentRef, id: contentId })] }));
};
Tabs.Tab = Tab;
